import React from 'react'
import MenuLateralNovoItems from './MenuLateralNovoItems'

import { motion } from 'framer-motion'

const LeftMenu = () => {

    const divMenuConteinerStyle = {
        minWidth: "249px",
        display: "flex",
        flexFlow: "column",
        borderRight: "1px solid rgba(0, 0, 0, 0.12)"
    }

    return (
        <motion.div style={divMenuConteinerStyle} initial={{ x: "-100%" }} animate={{ x: "0" }} transition={{ type: "tween", duration: 0.5 }}>
           
           <nav style={{marginTop:"17px"}}>
                <div style={{ width: "100%" }}>                    
                    <MenuLateralNovoItems link="/SomaPlace/my-register"> MEU CADASTRO </MenuLateralNovoItems>
                    <MenuLateralNovoItems link="/SomaPlace/contracts"> CONTRATOS ACEITOS </MenuLateralNovoItems>
                </div>
            </nav>
        </motion.div>
    )}

export default LeftMenu